import Me from './me'
import Memberships from './membership'

export default class User {
  static Me = Me
  static Memberships = Memberships
}
